import { observer } from 'mobx-react-lite'
import { useRouterStore } from '../../../RouterStore'
import { routes } from '../../RouteConfig'
import useStore from 'reusable/mobx-store-utils'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button'

export default observer(function AnnouncementXPMSyncErrors() {
   const routerStore = useRouterStore()
   const announcementXPMSyncErrorsStore = useStore(() => ({
      navigateToClientSyncLog: () => routerStore.navigateToRoute(routes['my-organisation'], 'client-sync-log')
   }))

   return <>
      <ErrorOutlineIcon sx={{ mr: 1, color: 'error.dark', fontSize: '20px' }} />
      Sync from Xero Practice Manager completed with errors.
      <Button variant="text" sx={{ ml: 0.5 }} onClick={announcementXPMSyncErrorsStore.navigateToClientSyncLog}>View logs</Button>
   </>
})
